import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

export const Grid = ({ children }) => <ul className={styles.grid}>{children}</ul>;

export const Cell = ({ children }) => <li className={styles.cell}>{children}</li>;

export const CellFullWidth = ({ children }) => (
  <li className={styles['cell-full-width']}>{children}</li>
);

Grid.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

Cell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

CellFullWidth.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};
